import React, {
  useMemo,
} from 'react';
import type {
  Entry,
} from 'contentful';
import {
  getStyles,
} from './BannerContainer.styles';
import Banner from '@/components/Banner';

type BannerContainerProps = {
  banners: Entry[];
  position: 'top' | 'bottom';
};

const BannerContainer = (props: BannerContainerProps): JSX.Element => {
  const {
    banners,
    position,
  } = props;

  const styles = getStyles();

  const bannerContainerStyles = useMemo(() => {
    if (position === 'top') return styles.bannerContainer;

    return {
      ...styles.bannerContainer,
      ...styles.bottom,
    }
  }, [position]);

  if (!banners?.length) return null;

  return (
    <div style={bannerContainerStyles}>
      {banners.map((banner) => (
        <Banner
          key={banner.sys.id}
          entry={banner}
        />
      ))}
    </div>
  );
};

export default BannerContainer;
